<template>
  <div class="shippingAddress">
    <div class="chinese-address" v-if="!isSelection">
      <div class="address-title">{{ $t.address.chinese1 }}</div>
      <div class="address-Wrapper">
        <div class="row">
          <van-image width="15" height="15" :src="warehouseIcon"></van-image>
          <span class="label1">7Seas 仓库</span>
        </div>
        <div class="row">
          <van-image width="15" height="15" :src="userIcon"></van-image>
          <span class="label2">KENT 陈先生</span>
        </div>
        <div class="row">
          <van-image width="15" height="15" :src="phoneIcon"></van-image>
          <span class="label2">15811854639</span>
        </div>
        <div class="row">
          <van-image width="15" height="15" :src="locationIcon"></van-image>
          <span class="label2">广州市西湖路18号广百新翼大厦2217室</span>
        </div>
        <div class="buttons">
          <van-button
            block
            type="info"
            color="#2750aa"
            :icon="copyIcon"
            size="small"
            style="border-radius: 10px"
            @click="onCopy"
            >{{ $t.address.copy }}</van-button
          >
        </div>
      </div>
    </div>
    <address-list
      :addressList="addressList"
      :isSelection="isSelection"
      @addressDidTap="actionAddressDidTap"
      @editAddress="editAddress"
    ></address-list>
    <div class="tool-bar">
      <van-button block @click="addAddress">
        {{ $t.address.addAddress }}
      </van-button>
    </div>
    <placeholder v-if="isPlaceholder"></placeholder>
  </div>
</template>
<script>
import AddressList from "./components/AddressList";
import Placeholder from "@/components/common/Placeholder";
import Vue from "vue";
import { Button, Image } from "vant";
Vue.use(Button).use(Image);

export default {
  name: "ShippingAddress",
  props: {
    isSelection: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AddressList,
    Placeholder,
  },
  data() {
    return {
      warehouseIcon: require("@/assets/img/shippingAddress/warehouse.png"),
      userIcon: require("@/assets/img/shippingAddress/user.png"),
      phoneIcon: require("@/assets/img/shippingAddress/phone.png"),
      locationIcon: require("@/assets/img/shippingAddress/location.png"),
      copyIcon: require("@/assets/img/shippingAddress/copy.png"),
      addressList: [],
      isPlaceholder: false,
    };
  },
  mounted() {
    this.getCustomerReceivingList();
  },
  methods: {
    onCopy() {
      var text =
        "仓库简称:7Seas , 联系人:KENT 陈先生 , 联系电话 : 15811854639 , 地址:广州市西湖路18号广百新翼大厦2217室";
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.cargoInquiry.copySuccess,
      });
    },
    getCustomerReceivingList() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        let param = {};
        this.$api.address
          .getCustomerReceivingList(param)
          .then((res) => {
            const data = res.data;
            this.addressList = data;
            if (data == null || data === "" || data.length === 0) {
              this.isPlaceholder = true;
            } else {
              this.isPlaceholder = false;
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    addAddress() {
      if (this.isSelection) {
        this.$emit("addAddress");
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: false,
          path: "editAddress",
          name: "editAddress",
          query: [],
        });
      }
    },
    actionAddressDidTap(address) {
      if (this.isSelection) {
        this.$emit("selectedAddress", address);
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: `editAddress/${address.CRId}`,
          name: "EditAddress",
          query: [
            {
              name: "Address",
              value: address,
            },
          ],
        });
      }
    },
    editAddress(address) {
      if (this.isSelection) {
        this.$emit("editAddress", address);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.shippingAddress {
  width: 100%;
  .selectionBox {
    position: absolute !important;
    bottom: calc(0px + env(safe-area-inset-bottom)) !important;
  }
  .chinese-address {
    padding: 4%;
    .address-title {
      color: #000000;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 4%;
    }
    .address-Wrapper {
      padding: 4% 6%;
      text-align: left;
      background-color: #fffdf7;
      border-radius: 10px;
      box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 30%);
      .row {
        vertical-align: middle;
        display: inline-block;
        width: 100%;
        margin-bottom: 2%;
        .van-image {
          vertical-align: middle;
        }
        .label1 {
          font-size: 14px;
          font-weight: 500;
          vertical-align: middle;
          display: inline-block;
          margin-left: 5px;
        }
        .label2 {
          font-size: 12px;
          font-weight: normal;
          vertical-align: middle;
          display: inline-block;
          margin-left: 5px;
        }
      }
      .buttons {
        margin-top: 2%;
        text-align: center;
        .van-button {
          height: 35px;
        }
        ::v-deep .van-button__text {
          font-size: 12px !important;
        }
        ::v-deep .van-icon__image {
          font-size: 12px !important;
        }
      }
    }
  }
  .tool-bar {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 2.5%;
    z-index: 10;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      width: 90%;
      margin: auto;
      border: none;
      border-radius: 10px;
      color: #ffffff;
      background: #2750aa !important;
      .van-button__icon {
        margin-top: 2px;
      }
      .van-button__text {
        font-size: 14px !important;
      }
    }
  }
}
</style>
